import React, { useState, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Carousel } from "primereact/carousel";
import { SplitButton } from "primereact/splitbutton";
import { confirmDialog } from "primereact/confirmdialog";
import { Button, Dialog, Calendar, InputText, Checkbox, InputTextarea, classNames, } from "primereact";

// ------------------ COMPONENTES DE BASE --------------------------------
import Card from "../../../../../../Base/Components/Card/Card";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";

// ------------------- CONSULTAS A LA API --------------------------------
import { ObtenerSiguienteNoRequisa } from "../../../../../../API/Compras/Requisas/PurchaseRequest";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import ReportePR from "../../Reporte/ReportePR";
import ArchivosRequisicion from "./ArchivosRequisicion";
import { CorreoAsignacion } from "../../Correos/CorreoAsignacion";
import { CorreoAprobacion } from "../../Correos/CorreoAprobacion";

const EncabezadoRequisicion = ({
  values,
  priorities,
  type,
  handleInputChange,
  areas,
  agentes,
  agentesCompras,
  habilitar,
  setHabilitar,
  resetForm,
  detalles,
  guardarDetalleRequisicion,
  toast,
  setValues,
  getRequisa,
  agregarNuevaFila,
  eliminarItemDetalle,
  botonReporteHabilitado,
  setDetalles,
  setMostrarCarousel,
  mostrarCarousel,
  imagenes = [],
  enviarCorreoAsignacion,
  setRequisaToShow
}) => {

  const { userAuth } = useContext(AuthContext);
  const [loadingCorreo, setLoadingCorreo] = useState(false);
  const [NoRequisa, setNoRequisa] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showReporte, setShowReporte] = useState(false);
  const [Language, setLanguage] = useState('es');

  const [asignarRequisa] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(40) || userAuth.IdRol === 1);

  const habilitarComponentes = () => {
    setHabilitar(true);
  };

  const ISVList = [
    { label: 'Sin ISV', value: 0 },
    { label: '15%', value: 0.15 },
    { label: '12%', value: 0.12 },
    { label: '17%', value: 0.17 },
  ];

  // OBTENER INFO. PARA NUEVA REQUISA
  const getInfoNew = async () => {
    setLoading(true);
    const NRequisa = await ObtenerSiguienteNoRequisa();
    setNoRequisa(NRequisa);

    const d = {
      IdStatus: 11,
      StatusName: "Creada",
      DateCreated: new Date(),
      IdPurchaseRequest: -100,
      Comment: "",
      PurchaseRequest: NRequisa[0].PurchaseRequest,
    };
    
    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  const nuevaRequisa = () => {
    confirmDialog({
      message: "Esta seguro que desea crear una nueva Requisa",
      header: "Nueva Requisa",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        // Limpia el formulario antes de obtener nueva información
        resetForm();
        setDetalles([]);
        getInfoNew();
        setRequisaToShow(null);
        habilitarComponentes();
        setMostrarCarousel(false);
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const abrirModal = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const cerrarModal = () => {
    setShowModal(false);
  };

  const items = [
    {
      className: "p-componentt",
      label: "Ingles",
      icon: "",
      command: () => {
        // setLan(1)
        // setShow(true)
        // setNotOpen(true)
        // window.open(
        //   `${process.env.REACT_APP_ENV}/PurchaseRequest/print/${values.PurchaseRequest}/1`,
        //   values.PurchaseRequest,
        //   "height=1200,width=1000"
        // );
        setShowReporte(true)
        setLanguage('en')
      },
    },
    {
      label: "Español",
      icon: "",
      command: () => {
        // window.open(
        //   `${process.env.REACT_APP_ENV}/PurchaseRequest/print/${values.PurchaseRequest}/2`,
        //   values.PurchaseRequest,
        //   "height=1200,width=1000"
        // );
        setShowReporte(true)
        setLanguage('es')
      },
    },
  ];

  const verificarCampos = () => {
    let err = false;
    if (!values.Priority) {
      err = true;
      toastShow(
        toast,
        "error",
        "Error",
        "Debe seleccionar la prioridad de la requisa."
      );
    } else if (!values.Type) {
      err = true;
      toastShow(
        toast,
        "error",
        "Error",
        "Debe seleccionar el tipo de requisa."
      );
    } else if (!values.Area) {
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar un departamento.");
    } else if (!values.UserRequest) {
      err = true;
      toastShow(
        toast,
        "error",
        "Error",
        "Debe seleccionar el agente al que se le solicita."
      );
    } else if (!values.Comment) {
      err = true;
      toastShow(
        toast,
        "error",
        "Error",
        "Debe ingresar un comentario a la requisa."
      );
    }
    return !err;
  };

  const handleISV15Change = (e) => {
  // Actualiza el valor de values.Inp
  handleInputChange(e);

  // Solo limpiamos TAX si el usuario está DESMARCANDO el check
  if (!e.checked) {
    const nuevosDetalles = detalles.map((detalle) => {

      const cantidad = Number(detalle.Quantity || 0);
      const precio = Number(detalle.Price || 0);
      const isv18 = Number(detalle.ISV18 || 0);
      const descuento = Number(detalle.Discount || 0);

      const subtotal = cantidad * precio;

      return {
        ...detalle,

        // Quitamos únicamente el ISV 15%
        TAX: 0,

        // Mantenemos el subtotal correcto
        SubTotal: subtotal,

        // Total sin ISV 15%
        Total: subtotal + isv18 - descuento,
      };
    });

    setDetalles(nuevosDetalles);
  }
};

  const isFormFieldValid = () => {};

  return (
    <div className="form-demo px-3 mb-2 mt-2">
      <div className="d-flex flex-column justify-content-center">
        <Card
          contenido={
            <div className="d-flex">
              <div className="col-10">
                <div className="d-flex flex-wrap align-items-start gap-3 mt-2">
                  <span className="p-inputgroup " style={{ maxWidth: 235 }}>
                    <span className=" field p-float-label">
                      <InputText
                        id="PurchaseRequest"
                        name="PurchaseRequest"
                        value={values?.PurchaseRequest}
                        autoFocus
                        style={{ fontSize: "x-large" }}
                        onChange={handleInputChange}
                        className={classNames("p-inputtext-sm block", {
                          "p-invalid": isFormFieldValid("idEncabezado"),
                        })}
                        onKeyDown={(e) =>
                          e.keyCode === 13 ? getRequisa() : null
                        }
                      />
                      <label htmlFor="idEncabezado">No. Requisición</label>
                    </span>

                    <Button
                      icon="pi pi-search"
                      type="button"
                      onClick={() => getRequisa()}
                      tooltip="Buscar Requisa"
                      tooltipOptions={{position: "top"}}
                      tabIndex={-1}
                    />
                  </span>

                  <span className="p-float-label">
                    <Calendar
                      id="DateCreated"
                      name="DateCreated"
                      disabled
                      value={values?.DateCreated}
                      dateFormat="dd/mm/yy"
                      mask="99/99/9999"
                      showIcon
                    />
                    <label htmlFor="Date">Fecha Creación</label>
                  </span>

                  <span className=" p-float-label">
                    <InputText
                      id="estado"
                      disabled
                      name="estado"
                      value={values?.StatusName}
                      className={classNames({
                        "p-inputtext-sm block": isFormFieldValid("estado"),
                      })}
                      style={{ width: "100%", padding: "6px 3px" }}
                    />
                    <label
                      htmlFor="estado"
                      className={classNames({
                        "p-error": isFormFieldValid("estado"),
                      })}
                    >
                      Estado
                    </label>
                  </span>

                  <span className=" p-float-label">
                    <InputText
                      disabled
                      id="UserCreate"
                      name="UserCreate"
                      readOnly
                      value={values?.UserName || userAuth?.UserName}
                      autoFocus
                      style={{ width: "100%", padding: "6px 3px" }}
                      className={classNames({
                        "p-error": isFormFieldValid("usuario"),
                      })}
                    />
                    <label
                      htmlFor="usuarioCSM"
                      className={classNames({
                        "p-error": isFormFieldValid("usuarioCSM"),
                      })}
                    >
                      Usuario
                    </label>
                  </span>

                  <AutoCompleteDropdown
                    enable={habilitar}
                    name={"Priority"}
                    value={values.Priority}
                    items={priorities}
                    field={"Priority"}
                    label={"Prioridad"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    tabIndex={3}
                  />

                  <AutoCompleteDropdown
                    enable={habilitar}
                    name={"Type"}
                    value={values.Type}
                    items={type}
                    field={"Type"}
                    label={"Tipo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    tabIndex={4}
                  />

                  <AutoCompleteDropdown
                    enable={habilitar}
                    name={"Area"}
                    value={values.Area}
                    items={areas}
                    field={"Area"}
                    label={"Departamento"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    tabIndex={5}
                  />

                  <AutoCompleteDropdown
                    enable={habilitar}
                    value={values.UserRequest}
                    items={agentes}
                    field={"UserName"}
                    name={"UserRequest"}
                    handleInputChange={handleInputChange}
                    tabIndex={6}
                    label={"Solicita"}
                  />

                  {asignarRequisa && (
                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values.UserNameAgente}
                      items={agentesCompras}
                      name={"UserNameAgente"}
                      field={"UserNameAgente"}
                      handleInputChange={handleInputChange}
                      // tabIndex={7}
                      label={"Asignado a"}
                    />
                  )}

                  <span
                    className=" p-float-label d-flex mt-0"
                    style={{ alignItems: "flex-end" }}
                  >
                    <InputTextarea
                      tabIndex={7}
                      disabled={!habilitar}
                      id="Comment"
                      autoResize={true}
                      name="Comment"
                      value={values?.Comment}
                      onChange={handleInputChange}
                      rows={3}
                      cols={100}
                      placeholder
                      className={classNames(" block", "encabezado__contenido", {
                        "p-invalid": isFormFieldValid("Comment"),
                      })}
                      style={{
                        width: "100%",
                        maxHeight: "4.5rem",
                        maxWidth: "70vh",
                        height: "3rem",
                      }}
                    />
                    <label
                      id="label_comentario"
                      htmlFor="Comment"
                      className={classNames("encabezado__contenido", {
                        "p-error": isFormFieldValid("Comment"),
                      })}
                    >
                      Comentarios
                    </label>
                  </span>
                </div>

                {/* ------------------------------------------------BOTONES------------------------------------------------------- */}
                <div className="d-flex flex-wrap gap-3 mb-2 col-12">
                  <div className="groupEncabezado encabezado__contenido-Card d-flex gap-1 mt-3 flex-wrap justify-content-between">
                    <Button
                      icon="pi pi-plus"
                      disabled={!habilitar}
                      type="button"
                      // className="p-button-info encabezado__herramienta-botones"
                      tooltip="Agregar Items"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      onClick={(e) => {
                        if (verificarCampos()) {
                          agregarNuevaFila();
                        }
                      }}
                      tabIndex={7}
                    />
                    <Button
                      icon="pi pi-save"
                      disabled={!habilitar}
                      className="p-button-primary encabezado__herramienta-botones"
                      tooltip="Guardar"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      style={{ marginLeft: 1 }}
                      onClick={(e) => {
                        if (verificarCampos()) {
                          guardarDetalleRequisicion();
                        }
                      }}
                    />
                    <Button
                      icon="pi pi-pencil"
                      type="button"
                      className="p-button-secondary  encabezado__herramienta-botones"
                      onClick={habilitarComponentes}
                      tooltip="Editar"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      disabled={detalles?.length <= 0}
                      style={{ marginLeft: 1 }}
                    />
                    <Button
                      icon="pi pi-times"
                      type="button"
                      className="p-button-danger encabezado__herramienta-botones"
                      onClick={() => eliminarItemDetalle()}
                      tooltip="Cancelar"
                      disabled={!habilitar || detalles?.length <= 0}
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      style={{ marginLeft: 1 }}
                    />
                    <Button
                      icon="pi pi-book"
                      type="button"
                      onClick={nuevaRequisa}
                      tooltip="Nueva"
                      style={{ marginLeft: 1 }}
                    />

                    <div className="d-flex flex-row">
                      <SplitButton
                        disabled={!botonReporteHabilitado}
                        label=""
                        icon="pi pi-print"
                        onClick={(e) => {
                          // window.open(
                          //   `${process.env.REACT_APP_ENV}/PurchaseRequest/print/${values?.PurchaseRequest}/2`,
                          //   values.PurchaseRequest,
                          //   "height=1200,width=1000"
                          // );
                          setShowReporte(true)
                          setLanguage('es')
                        }}
                        model={items}
                      />
                    </div>

                    {values?.IdPurchaseRequest > 0 && 
                      <Button
                        icon="pi pi-envelope"
                        type="button"
                        loading={loadingCorreo}
                        tooltip="Enviar Correo"
                        onClick={(e) => enviarCorreoAsignacion()}
                      />
                    }
                    <Button
                      icon="pi pi-sync"
                      type="button"
                      onClick={() => getRequisa()}
                      tooltip="Cargar"
                      style={{ marginLeft: 1 }}
                    />

                    {values?.IdPurchaseRequest > 0 &&(
                      <ArchivosRequisicion
                        IdPurchaseRequest={values?.IdPurchaseRequest}
                        PurchaseRequest={values?.PurchaseRequest}
                      />
                    )
                    }
                  </div>
                  <div className="d-flex encabezado__contenido-Card flex-wrap justify-content-between mt-3">
                    <span
                      className="p-inputgroup encabezado__span-idEncabezado mt-2"
                      style={{ marginLeft: 2 }}
                    >
                      <span
                        className="p-float-label encabezado__boton-archivo"
                        style={{ verticalAlign: "center" }}
                      >
                        <span className="mx-2">Cálculo ISV 15%: </span>
                        <Checkbox
                          id="Inp"
                          disabled={!habilitar}
                          name="Inp"
                          checked={values.Inp}
                          onChange={handleISV15Change}
                          label="ISV"
                        />
                      </span>

                      <span
                        className="p-float-label encabezado__boton-archivo mx-4"
                        style={{ verticalAlign: "center" }}
                      >
                        <span className="mx-2">Cálculo ISV 18%: </span>
                        <Checkbox
                          id="ISV18_Porciento"
                          disabled={!habilitar}
                          name="ISV18_Porciento"
                          checked={values.ISV18_Porciento}
                          onChange={handleInputChange}
                        />
                      </span>

                    </span>
                  </div>
                </div>
              </div>

              {mostrarCarousel && (
                <div
                  className="col-2 d-flex"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                    }}
                  >
                    {imagenes.CodigoProducto && (
                      <Carousel
                        value={imagenes.img}
                        circular
                        showIndicators={false}
                        itemTemplate={(item) => {
                          return (
                            <div
                              className="d-flex"
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                height: "150px",
                              }}
                            >
                              <img
                                src={"data:image/png;base64," + item}
                                alt="imagen"
                                width="170vh"
                                onClick={() => abrirModal(item)}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          );
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          }
        />
      </div>

      {/* Dialogo para mostrar imagenes */}
      <Dialog
        header={imagenes ? imagenes?.NombreProducto : ""}
        visible={showModal}
        onHide={cerrarModal}
        className="w-50"
      >
        <div style={{ maxWidth: "100%", maxHeight: "100%" }}>
          {imagenes.CodigoProducto && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>

      <div style={{ display: "none" }}>
        <div id="CorreoAsignacion">
          <CorreoAsignacion />
        </div>
      </div>

      <div style={{ display: "none" }}>
        <div id="CorreoAprobacion">
          <CorreoAprobacion detalles={detalles} />
        </div>
      </div>

      {showReporte && (
        <ReportePR
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selectedDetalle={[values]}
          setLanguaje={setLanguage}
          Language={Language}
        />
      )}
    </div>
  );
};

export default EncabezadoRequisicion;
